import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRailCommandLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1500,
	zoomAndPan: "magnify",
	viewBox: "0 0 1125 337.499995",
	height: 450,
	preserveAspectRatio: "xMidYMid meet",
	id: "svg147",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", {
			id: "defs13",
			children: [
				/* @__PURE__ */ _jsx("g", { id: "g2" }),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "ad84696229",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M 0.832031 0 L 1124.167969 0 L 1124.167969 337 L 0.832031 337 Z M 0.832031 0 ",
						clipRule: "nonzero",
						id: "path4"
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "8284741ac6",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M 339.585938 9 L 1114.351562 9 L 1114.351562 328 L 339.585938 328 Z M 339.585938 9 ",
						clipRule: "nonzero",
						id: "path7"
					})
				}),
				/* @__PURE__ */ _jsx("clipPath", {
					id: "8524959a68",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M 1060.085938 153.308594 L 1090.789062 153.308594 L 1090.789062 184.015625 L 1060.085938 184.015625 Z M 1060.085938 153.308594 ",
						clipRule: "nonzero",
						id: "path10"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#ad84696229)",
			id: "g23",
			children: /* @__PURE__ */ _jsx("rect", {
				x: -112.5,
				width: 1350,
				fill: "#014d73",
				y: -33.75,
				height: 404.999994,
				fillOpacity: 1,
				id: "rect21"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#8284741ac6)",
			id: "g27",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#ffffff",
				d: "M 339.585938 9 L 1114.441406 9 L 1114.441406 327.554688 L 339.585938 327.554688 Z M 339.585938 9 ",
				fillOpacity: 1,
				fillRule: "nonzero",
				id: "path25"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#014d73",
			fillOpacity: 1,
			id: "g59",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(604.639137, 145.369394)",
				id: "g57",
				children: /* @__PURE__ */ _jsx("g", { id: "g55" })
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#8524959a68)",
			id: "g119",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#014d73",
				d: "M 1075.4375 155.203125 C 1068.015625 155.203125 1061.976562 161.238281 1061.976562 168.660156 C 1061.976562 176.082031 1068.015625 182.121094 1075.4375 182.121094 C 1082.859375 182.121094 1088.894531 176.082031 1088.894531 168.660156 C 1088.894531 161.238281 1082.859375 155.203125 1075.4375 155.203125 Z M 1075.4375 184.011719 C 1066.972656 184.011719 1060.085938 177.125 1060.085938 168.660156 C 1060.085938 160.195312 1066.972656 153.308594 1075.4375 153.308594 C 1083.902344 153.308594 1090.789062 160.195312 1090.789062 168.660156 C 1090.789062 177.125 1083.902344 184.011719 1075.4375 184.011719 ",
				fillOpacity: 1,
				fillRule: "nonzero",
				id: "path117"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#014d73",
			d: "M 1072.746094 168.261719 L 1075.636719 168.261719 C 1076.582031 168.261719 1077.324219 168.023438 1077.855469 167.542969 C 1078.390625 167.066406 1078.65625 166.414062 1078.65625 165.585938 C 1078.65625 164.71875 1078.410156 164.046875 1077.917969 163.574219 C 1077.425781 163.101562 1076.691406 162.855469 1075.710938 162.839844 L 1072.746094 162.839844 Z M 1075.878906 170.527344 L 1072.746094 170.527344 L 1072.746094 176.746094 L 1069.9375 176.746094 L 1069.9375 160.574219 L 1075.625 160.574219 C 1077.488281 160.574219 1078.929688 160.996094 1079.945312 161.832031 C 1080.957031 162.667969 1081.464844 163.878906 1081.464844 165.464844 C 1081.464844 166.546875 1081.203125 167.453125 1080.683594 168.183594 C 1080.160156 168.914062 1079.433594 169.476562 1078.5 169.867188 L 1082.132812 176.601562 L 1082.132812 176.746094 L 1079.121094 176.746094 L 1075.878906 170.527344 ",
			fillOpacity: 1,
			fillRule: "nonzero",
			id: "path121"
		}),
		/* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			style: {
				fontStyle: "normal",
				fontVariant: "normal",
				fontWeight: "bold",
				fontStretch: "normal",
				fontSize: "155.559px",
				fontFamily: "'Open Sans'",
				InkscapeFontSpecification: "'Open Sans, Bold'",
				fontVariantLigatures: "normal",
				fontVariantCaps: "normal",
				fontVariantNumeric: "normal",
				fontVariantEastAsian: "normal",
				fill: "#ffffff",
				fillOpacity: 1,
				strokeWidth: .747879
			},
			x: 152.96671,
			y: 224.79237,
			id: "text1150",
			transform: "scale(1.0000586,0.99994141)",
			children: /* @__PURE__ */ _jsx("tspan", {
				id: "tspan1148",
				style: {
					fill: "#ffffff",
					fillOpacity: 1,
					strokeWidth: .747879
				},
				x: 152.96671,
				y: 224.79237,
				children: "S"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			style: {
				fontStyle: "normal",
				fontVariant: "normal",
				fontWeight: "bold",
				fontStretch: "normal",
				fontSize: "155.56px",
				fontFamily: "'Open Sans'",
				InkscapeFontSpecification: "'Open Sans, Bold'",
				fontVariantLigatures: "normal",
				fontVariantCaps: "normal",
				fontVariantNumeric: "normal",
				fontVariantEastAsian: "normal",
				fill: "#ffffff",
				fillOpacity: 1,
				strokeWidth: .747883
			},
			x: 238.64391,
			y: 224.78697,
			id: "text1306",
			transform: "scale(1.0000158,0.9999842)",
			children: /* @__PURE__ */ _jsx("tspan", {
				id: "tspan1304",
				style: {
					strokeWidth: .747883,
					fill: "#ffffff",
					fillOpacity: 1
				},
				x: 238.64391,
				y: 224.78697,
				children: "I"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			style: {
				fontStyle: "normal",
				fontVariant: "normal",
				fontWeight: "bold",
				fontStretch: "normal",
				fontSize: "155.574px",
				fontFamily: "'Open Sans'",
				InkscapeFontSpecification: "'Open Sans, Bold'",
				fontVariantLigatures: "normal",
				fontVariantCaps: "normal",
				fontVariantNumeric: "normal",
				fontVariantEastAsian: "normal",
				fill: "#ffffff",
				fillOpacity: 1,
				strokeWidth: .747949
			},
			x: 50.265396,
			y: 224.80713,
			id: "text1310",
			transform: "scale(1.0001051,0.99989493)",
			children: /* @__PURE__ */ _jsx("tspan", {
				id: "tspan1308",
				style: {
					strokeWidth: .747949,
					fill: "#ffffff",
					fillOpacity: 1
				},
				x: 50.265396,
				y: 224.80713,
				children: "R"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			style: {
				fontStyle: "normal",
				fontVariant: "normal",
				fontWeight: "normal",
				fontStretch: "normal",
				fontSize: "119.877px",
				fontFamily: "'Open Sans'",
				InkscapeFontSpecification: "'Open Sans, Normal'",
				fontVariantLigatures: "normal",
				fontVariantCaps: "normal",
				fontVariantNumeric: "normal",
				fontVariantEastAsian: "normal",
				fill: "#014d73",
				fillOpacity: 1,
				strokeWidth: .576335
			},
			x: 359.14944,
			y: 145.32654,
			id: "text1320",
			transform: "scale(0.99970689,1.0002932)",
			children: /* @__PURE__ */ _jsx("tspan", {
				id: "tspan1318",
				style: {
					strokeWidth: .576335,
					fill: "#014d73",
					fillOpacity: 1
				},
				x: 359.14944,
				y: 145.32654,
				children: "RAIL"
			})
		}),
		/* @__PURE__ */ _jsx("text", {
			xmlSpace: "preserve",
			style: {
				fontStyle: "normal",
				fontVariant: "normal",
				fontWeight: "bold",
				fontStretch: "normal",
				fontSize: "129.892px",
				fontFamily: "'Open Sans'",
				InkscapeFontSpecification: "'Open Sans, Bold'",
				fontVariantLigatures: "normal",
				fontVariantCaps: "normal",
				fontVariantNumeric: "normal",
				fontVariantEastAsian: "normal",
				fill: "#014d73",
				fillOpacity: 1,
				strokeWidth: .62448
			},
			x: 358.98132,
			y: 280.97339,
			id: "text1540",
			children: /* @__PURE__ */ _jsx("tspan", {
				id: "tspan1538",
				style: {
					strokeWidth: .62448,
					fill: "#014d73",
					fillOpacity: 1
				},
				x: 358.98132,
				y: 280.97339,
				children: "COMMAND"
			})
		}),
		/* @__PURE__ */ _jsx("style", { children: "\n        @font-face {\n    font-family: 'Open Sans';\n    src: url(data:application/font-woff2;charset=utf-8;base64,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) format('woff2');\n    font-weight: bold;\n    font-style: normal;\n\n}\n\n@font-face {\n    font-family: 'Open Sans';\n    src: url(data:application/font-woff2;charset=utf-8;base64,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) format('woff2');\n    font-weight: normal;\n    font-style: normal;\n\n}\n       " })
	]
});
export default SvgRailCommandLogo;
